import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core'
import { DOCUMENT } from '@angular/common'
import { EnvironmentService } from '../../environment/environment.service'

/* Matches the current path with a localized schema */
export function matchLocalizedPath(pathname: string = location.pathname) {
    return pathname.match('^/([a-z]{2})-([A-Z]{2})')
}

/* Retrieves the path without the locale */
export function getPathWithoutLocale(path: string = location.pathname) {
    const match = matchLocalizedPath(path)
    return match ? path.replace(match[0], '') : path
}

@Injectable({
    providedIn: 'root',
})
export class LocaleService {
    private renderer: Renderer2

    constructor(
        @Inject(DOCUMENT) private document,
        rendererFactory2: RendererFactory2,
        private environmentService: EnvironmentService
    ) {
        this.renderer = rendererFactory2.createRenderer(null, null)

        this.syncLocaleMetadata()
    }

    get country(): string {
        return this.environmentService.environment.locale.countryCode
    }

    get language(): string {
        return this.environmentService.environment.locale.languageCode
    }

    get locale(): string {
        return !this.language || !this.country ? null : `${this.language}-${this.country}`
    }

    // make sure the locale attribute on the html tag reflects the current locale
    private syncLocaleMetadata() {
        // set language tag in html attribute
        const htmlElement = this.document.querySelector('html')
        this.renderer.setAttribute(htmlElement, 'lang', this.locale)
        this.renderer.setAttribute(htmlElement, 'xml:lang', this.locale)
    }
}
